<template>
  <div v-if="groupVisibility">
    <v-scale-transition origin="center center">
      <ConcentricCircles
        v-show="markerVisible"
        class="hotspot-circle-map-marker"
        :style="markerPosition"
      />
    </v-scale-transition>
    <v-scale-transition origin="center center" v-if="showImagePreview && markerType==='imagepreviewpopup'">
      <span :aria-label="arialabel">
          <span class="image-preview-arrow" :style="imagePreviewPosition"></span>
          <v-img 
            :src="thumbnailImage" 
            class="image-preview" 
            :style="imagePreviewPosition" 
            ref="imagePreviewRef"
            :cover="true"
            position="center"            
          />
      </span>

    </v-scale-transition>

    <v-btn
      v-if="isMarkerFromTour == true"
      :color="hotspotBackgroundColor"
      class="map-marker details-button white--text"
      :style="markerPosition"
      :aria-label="ariaLabel"
      @mouseenter="showCircle = false"
      @mouseleave="showCircle = true"
      @focus="mapHotspotFocus()"
      @click="$emit('setIndex')"
    >
      <v-icon class="marker-icon" v-if="icon !== null" :color="hotspotTextColor">{{ icon }}</v-icon>
      <span class="d-inline-block text-center marker-title" :color="hotspotTextColor">{{ title }}</span>
    </v-btn>

    <v-btn
      v-else
      :color="hotspotBackgroundColor"
      class="map-marker details-button white--text"
      :style="markerPosition"
      :aria-label="ariaLabel"
      :data-testid="'hotspot-btn' + id"
      @mouseenter="onMouseEnterPopup"
      @mouseleave="onMouseLeavePopup"
      @focus="mapHotspotFocus()"
      @focusout="mapHotspotFocusOut"
    >
 
      <v-icon class="marker-icon" v-if="icon !== null" :color="hotspotTextColor">{{ icon }}</v-icon>
      <span class="d-inline-block text-center marker-title":color="hotspotTextColor">{{ title }}</span>
    </v-btn>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import ConcentricCircles from "../panorama/ConcentricCircles.vue";

export default {
  name: "MapMarkerArcHtml",
  props: [
    "id",
    "coordinates",
    "colour",
    "icon",
    "mapCenter",
    "mapArc",
    "title",
    "arialabel",
    "markerVisible",
    "markerType",
    "currZoomLevel",
    "zoomMarkerFlag",
    "isMarkerFromTour",
    "layerData",
    "hotspotGroupData",
    "thumbnailImage"
  ],
  data: () => ({
    screenXY: undefined,
    currentFocusIndex: 0,
    showCircle: true,
    markerVisibility: true,
    hotspotBackgroundColor: '',
    hotspotTextColor: '',
    groupVisibility: null,
    showImagePreview: false,
  }),

  components: { ConcentricCircles },

  mounted() {
    this.markerObject = undefined;
    this.handler = undefined;
    this.point = undefined;
    this.configureHotspotGroups();
  },
  created() {
    const self = this;

    loadModules(["esri/geometry/Point"], {
      css: true,
    }).then(([Point]) => {
      self.point = new Point({
        longitude: self.coordinates[0],
        latitude: self.coordinates[1],
      });
    });
  },
  beforeDestroy() {
    if (this.handler !== undefined) this.handler.remove();

    if (this.markerObject !== undefined)
      this.markerLayer.remove(this.markerObject);
  },
  computed: {

    markerPosition() {
      if (this.screenXY === undefined) {
        console.log("No XY");
        return "display:none";
      }

      let screenY = this.screenXY.y - 18;
      let screenX = this.screenXY.x;
      // console.log("XY Found: " + screenX + "x " + screenY + "y");
      return (
        "z-index:1; display:inline-block; top: " +
        screenY +
        "px; left: " +
        screenX +
        "px;"
      );
    },
    imagePreviewPosition() {
      if (this.screenXY === undefined) {
        return "display:none";
      }

      let screenY = this.screenXY.y - 150;
      let screenX = this.screenXY.x - 90;
      return (
        "z-index:1; display:inline-block; top: " +
        screenY +
        "px; left: " +
        screenX +
        "px;"
      );
    },
    ariaLabel() {
      return this.arialabel;
    },
    visibleHotspotGroups() {
      return this.$store.getters["wagtail/getVisibleHotspotGroups"];
    },
  },
  watch: {
    mapCenter: {
      handler(newVal, oldVal) {
        // console.log("Map Center Watcher Triggered");
        this.updatedScreenXY();
      },
      deep: true,
    },
    visibleHotspotGroups(newValue, oldValue) {
      // Your code here. This function will run whenever the getter's value changes.
      this.checkGroupVisibility();
    },
  },
  methods: {
    onMouseEnterPopup() {
      this.showCircle = false
      this.showImagePreview = true
    }, 
    onMouseLeavePopup() {
      this.showCircle = true
      this.showImagePreview = false

    },
    configureHotspotGroups() {
      if (this.hotspotGroupData !== null && this.hotspotGroupData !== undefined) {
        console.log("[HSG]", this.hotspotGroupData);

        if (this.hotspotGroupData.primary_colour_override !== null) {
          this.hotspotTextColor = this.hotspotGroupData.primary_colour_override;
        } else {
          this.hotspotTextColor = '#ffffff';
        }

        if (this.hotspotGroupData.secondary_colour_override !== null) {
          this.hotspotBackgroundColor = this.hotspotGroupData.secondary_colour_override;
        } else {
          this.hotspotBackgroundColor = this.$vuetify.theme.themes.light.secondary;
        }

        if (this.hotspotGroupData.visible_by_default == true) {
          this.groupVisibility = true;
        } else {
          this.groupVisibility = false;
        }

      } else {
        this.hotspotTextColor = '#ffffff'
        this.hotspotBackgroundColor = this.$vuetify.theme.themes.light.secondary;
        this.groupVisibility = true;
      }
    },
    checkGroupVisibility() {
      const isIdMatched = this.$store.getters["wagtail/getVisibleHotspotGroups"].some((groupNumber) => groupNumber === this.hotspotGroupData.id);
      if (isIdMatched) {
        // Logic for when the ID is found in the array
        console.log("HSG ID matched!");
        this.groupVisibility = true;
      } else {
        // Logic for when the ID is not found in the array
        console.log(
          "HSG ID not matched",
          this.hotspotGroupData.id,
          this.$store.getters["wagtail/getVisibleHotspotGroups"]
        );
        this.groupVisibility = false;
      }
    },
    updatedScreenXY: function () {
      if (
        this.point !== undefined &&
        this.mapArc !== undefined &&
        this.mapArc.view !== undefined
      ) {
        if (this.layerData) {
          loadModules(["esri/geometry/Point"], {
            css: true,
          }).then(([Point]) => {
            const point = new Point({
              longitude: this.layerData.lng,
              latitude: this.layerData.lat,
            });
            this.screenXY = this.mapArc.view.toScreen(point);
          });
        } else {
          this.screenXY = this.mapArc.view.toScreen(this.point);
        }
        // console.log("Updated XY");
      } else {
        console.log("Failed to update XY");
      }
    },
    nextFocus() {
      const elements = document.querySelectorAll(".map-marker");
      this.currentFocusIndex++;
      this.currentFocusIndex = this.currentFocusIndex % elements.length;
      elements[this.currentFocusIndex].focus();
    },
    prevFocus() {
      const elements = document.querySelectorAll(".map-marker");
      this.currentFocusIndex--;
      if (this.currentFocusIndex < 0)
        this.currentFocusIndex = elements.length - 1;
      this.currentFocusIndex = this.currentFocusIndex % elements.length;
      elements[this.currentFocusIndex].focus();
    },
    mapHotspotFocus() {
      this.showImagePreview = true;
      this.$emit("focused");
    },
    mapHotspotFocusOut() {
      this.showImagePreview = false;
    }
  },
};
</script>

<style scoped>
.image-preview {
  position: absolute;
  background-color: #ffffff;
  /* box-shadow: 0px -10px 20px 5px rgba(0, 0, 0, 0.4); */
  max-width: 180px;
  max-height: 120px;
  width: 180px;
  height: 120px;
  border-radius: 8px;
}


.image-preview-arrow {
    position: absolute;

    &:after {
      content: "";
      height: 0;
      width: 0;
      border-width: 0 20px 20px 20px;
      border-style: solid;
          
      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) rgb(255, 255, 255) rgba(0, 0, 0, 0.4);
      box-shadow: 0px 20px 70px 70px rgba(0, 0, 0, 0.4);
      rotate: 180deg;
      position: absolute;
      bottom: -20px;
      margin: auto;
      left: 0;
      top: 120px;
      right: -180px;
    }
  }

</style>
